<form (submit)="onSearch()" class="ap-filters-container">
    <div class="main-filters-container">
        <div class="ap-filters" #row>
            <div class="primary-filters filters-row">
                <se-ap-filters-row
                    (filterChanged)="onFilterChange($event.name, $event.idx, 0)"
                    (resetComboValue)="onResetComboSelectedValue($event.name, $event.idx, 0)"
                    (doSearch)="onSearch()"
                    [searchParams]="!!paramsGroupedByRow[0] ? paramsGroupedByRow[0] : []"
                    [rowSize$]="rowSize$"
                ></se-ap-filters-row>
            </div>
        </div>
        <div class="ap-actions">
            <div class="search-action se-flex-1">
                <button
                    class="se-button-no-ripple se-flex-1"
                    color="primary"
                    mat-stroked-button
                    matTooltip="{{ 'Search' | translate }}"
                    matTooltipShowDelay="500"
                >
                    <mat-icon class="search-filter-search-icon">search</mat-icon>
                    {{ "Search" | translate }}
                </button>
                <button
                    *ngIf="isMultiSearchEnabled && !!searchTypes?.length && searchTypes.length > 0"
                    [disabled]="isBusy || disableSearch"
                    mat-stroked-button
                    [matMenuTriggerFor]="searchTypeMenu"
                    color="primary"
                    id="multi-search-button"
                >
                    <mat-icon aria-label="Menu ricerche" matPrefix>keyboard_arrow_right</mat-icon>
                </button>
                <mat-menu #searchTypeMenu="matMenu" class="se-mat-menu" xPosition="after" yPosition="below">
                    <div *ngFor="let type of searchTypes" class="menu-items-container">
                        <button (click)="onChangeSearchType(type)" class="se-menu-button se-menu-button" mat-menu-item>
                            <span>{{ type.labelTranslationKey | translate }}</span>
                        </button>
                    </div>
                </mat-menu>
            </div>
            <div class="search-action se-flex-1">
                <button
                    (click)="handleResetAll()"
                    class="se-button-no-ripple se-flex-1"
                    color="primary"
                    mat-stroked-button
                    matTooltip="{{ 'CleanFiltersDetail' | translate }}"
                    matTooltipShowDelay="500"
                >
                    <mat-icon class="search-filter-search-icon">delete</mat-icon>
                    {{ "CleanFilters" | translate }}
                </button>
            </div>
            <div class="search-action">
                <se-ap-search-filters-config
                    [isCurrentUserAuthorized]="isCurrentUserAuthorized"
                    [searchParams]="searchParams"
                    (changeFilters)="onChangeFiltersConfiguration($event)"
                    [formType]="SearchFormType.EXECUTION"
                ></se-ap-search-filters-config>
            </div>
        </div>
    </div>

    <mat-accordion class="secondary-filters-panel">
        <mat-expansion-panel (closed)="secondaryFiltersOpen = false" (opened)="secondaryFiltersOpen = true">
            <mat-expansion-panel-header collapsedHeight="auto">
                <div class="applied-filters" [class.closed]="secondaryFiltersOpen">
                    <mat-chip-listbox aria-label="applied filters" multiple="true" selectable="false">
                        <mat-chip-option
                            (removed)="removeFilterChip(chip)"
                            *ngFor="let chip of appliedFilterChips"
                            [class.primary]="chip.primary"
                            class="custom-tooltip-chiplist"
                            [matTooltip]="
                                secondaryFiltersOpen
                                    ? null
                                    : (chip.labelTranslationKey | translate | uppercase) + ':\n' + chip.value
                            "
                        >
                            {{ chip.value }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-option>
                    </mat-chip-listbox>
                </div>
            </mat-expansion-panel-header>
            <div class="secondary-filters">
                <div *ngFor="let filterRow of paramsGroupedByRow.slice(1); let j = index" class="filters-row">
                    <se-ap-filters-row
                        (filterChanged)="onFilterChange($event.name, $event.idx, j + 1)"
                        (resetComboValue)="onResetComboSelectedValue($event.name, $event.idx, j + 1)"
                        [searchParams]="filterRow"
                        [rowSize$]="rowSize$"
                    ></se-ap-filters-row>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>
